import './footer.scss'

require.context('./static', true, /\.svg$/)
